import styled from '@emotion/styled'

import {NoStyleLink} from '@vio/atlas/src/components/designSystem/helpers/NoStyleLink'
import {Text} from '@vio/atlas/src/components/designSystem/Text'
import {cssTheme} from '@vio/atlas/src/themes'
import {linariaMq} from '@vio/atlas/src/utils/breakpoints'

export const SummaryWrapper = styled(NoStyleLink)`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${cssTheme.colors.content.neutral.primary};
  gap: ${cssTheme.layout.spacing.s100};
  width: 275px;

  .--row {
    display: flex;
    align-items: center;
    gap: ${cssTheme.layout.spacing.s300};
  }
  .--stars {
    width: 100px;
  }
  .--trustpilot-logo {
    height: auto;
    width: 72px;
  }
  .--trustpilot-logo-text {
    fill: ${cssTheme.colors.content.neutral.primary};
  }
  .--score-label {
    text-decoration: underline;
    font-size: 1.8rem;
    line-height: ${cssTheme.fonts.lineHeight.xs};
    vertical-align: middle;
    font-weight: ${cssTheme.fonts.weight.lg};
    margin-inline-end: ${cssTheme.layout.spacing.s200};
  }

  &.--theme-dark {
    color: ${cssTheme.colors.content.neutral.inverse};
    .--trustpilot-logo-text {
      fill: ${cssTheme.colors.content.neutral.inverse};
    }
  }
  &:visited,
  &:focus,
  &:active {
    .--score-label {
      text-decoration: underline;
    }
  }
  &:hover {
    .--score-label {
      text-decoration: none;
    }
  }
`

export const BannerWrapper = styled.div`
  display: flex;
  align-items: center;
  color: ${cssTheme.colors.content.neutral.primary};
  .--stars {
    width: 108px;
    margin-inline-start: ${cssTheme.layout.spacing.s250};
    margin-inline-end: ${cssTheme.layout.spacing.s400};
  }
  .--trustpilot-logo {
    height: auto;
    width: 74px;
    margin-top: -3px;
    margin-inline-start: ${cssTheme.layout.spacing.s200};
  }
  .--trustpilot-logo-text {
    fill: ${cssTheme.colors.content.neutral.primary};
  }

  &.--loading {
    gap: ${cssTheme.layout.spacing.s300};
  }
  &.--theme-dark {
    color: ${cssTheme.colors.content.neutral.inverse};
    .--trustpilot-logo-text {
      fill: ${cssTheme.colors.content.neutral.inverse};
    }
  }
`

export const PanelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${cssTheme.layout.spacing.s300};
  color: ${cssTheme.colors.content.neutral.primary};
  .--row {
    display: flex;
    align-items: center;
  }
  .--stars {
    width: 108px;
    margin: 0 ${cssTheme.layout.spacing.s250};
  }
  .--trustpilot-logo {
    height: auto;
    width: 74px;
    margin-top: -3px;
  }
  .--trustpilot-logo-text {
    fill: ${cssTheme.colors.content.neutral.primary};
  }

  &.--loading {
    gap: ${cssTheme.layout.spacing.s400};
    .--row {
      gap: ${cssTheme.layout.spacing.s300};
    }
  }
  &.--theme-dark {
    color: ${cssTheme.colors.content.neutral.inverse};
    .--trustpilot-logo-text {
      fill: ${cssTheme.colors.content.neutral.inverse};
    }
  }
`

export const CardWrapper = styled(NoStyleLink)`
  min-width: 144px;
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  color: ${cssTheme.colors.content.neutral.primary};
  margin: ${cssTheme.layout.spacing.s100};
  .--score {
    display: flex;
    align-items: center;
    gap: ${cssTheme.layout.spacing.s100};
  }
  .--trustpilot-logo {
    height: auto;
    width: 74px;
    margin-bottom: ${cssTheme.layout.spacing.s300};
  }
  .--stars {
    width: 127px;
    margin-bottom: ${cssTheme.layout.spacing.s300};
  }
  .--reviews-link {
    text-decoration: underline;
  }
  .--trustpilot-logo-text {
    fill: ${cssTheme.colors.content.neutral.primary};
  }
  &.--theme-dark {
    color: ${cssTheme.colors.content.neutral.inverse};
    .--trustpilot-logo-text {
      fill: ${cssTheme.colors.content.neutral.inverse};
    }
  }

  &:visited,
  &:focus,
  &:active {
    .--reviews-link {
      text-decoration: underline;
    }
  }
  &:hover {
    .--reviews-link {
      text-decoration: none;
    }
  }
`

export const BadgeWrapper = styled(NoStyleLink)`
  display: flex;
  width: fit-content;
  align-items: center;
  margin-bottom: ${cssTheme.layout.spacing.s200};

  .--stars {
    width: 130px;
    margin-inline-end: ${cssTheme.layout.spacing.s400};
  }
  .--trustpilot-logo {
    height: auto;
    width: 80px;
  }
  .--trustpilot-logo-text {
    fill: ${cssTheme.colors.content.neutral.primary};
  }
  .--stars-skeleton {
    margin-inline-end: ${cssTheme.layout.spacing.s400};
  }

  &.--theme-dark {
    .--trustpilot-logo-text {
      fill: ${cssTheme.colors.content.neutral.inverse};
    }
  }
`

export const InlineWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-top: ${cssTheme.layout.spacing.s200};
  color: ${cssTheme.colors.content.neutral.primary};
  .--stars {
    width: 108px;
    margin-inline-end: ${cssTheme.layout.spacing.s400};
  }
  .--trustpilot-logo-text {
    fill: ${cssTheme.colors.content.neutral.primary};
  }

  &.--loading {
    gap: ${cssTheme.layout.spacing.s300};
  }
  &.--theme-dark {
    color: ${cssTheme.colors.content.neutral.inverse};
    .--trustpilot-logo-text {
      fill: ${cssTheme.colors.content.neutral.inverse};
    }
  }
`

export const Separator = styled.span`
  padding: 0 ${cssTheme.layout.spacing.s200};
`

export const StyledText = styled(Text)`
  display: flex;
  align-items: center;
`

export const InlineLink = styled(NoStyleLink)`
  text-decoration: underline;
  &:visited,
  &:focus,
  &:active {
    text-decoration: underline;
  }
  &:hover {
    text-decoration: none;
  }
`

export const HeroWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center !important;
  gap: ${cssTheme.layout.spacing.s500};

  .--score-block {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .--score {
    font-size: 9.6rem !important;
    font-weight: 400 !important;
    line-height: 8.8rem !important;
    letter-spacing: -2px !important;
  }
  .--logo-wrapper {
    padding-top: ${cssTheme.layout.spacing.s600};
    padding-bottom: ${cssTheme.layout.spacing.s300};
  }
  .--reviews-block {
    display: flex;
    flex-direction: column;
  }
  &.--loading {
    gap: ${cssTheme.layout.spacing.s600};
  }
  .--reviews {
    text-align: center;
  }
  .--stars {
    width: 192px;
  }

  &.--theme-dark {
    color: ${cssTheme.colors.content.neutral.inverse};
    .--trustpilot-logo-text {
      fill: ${cssTheme.colors.content.neutral.inverse};
    }
  }
  ${linariaMq.desktopSm} {
    align-items: flex-start !important;
    gap: ${cssTheme.layout.spacing.s900};
    .--score-block {
      align-items: flex-start;
    }
    .--stars {
      width: 108px;
    }
    .--reviews {
      text-align: start;
    }
  }
`
